import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import {
  Badge,
  Button,
  Card,
  Input,
  MagnusOperaIcon,
  ThemeToggle,
} from "@insights/ui";
import { authClient } from "../../../api";
import { passwordResetRedirectUrl } from "../helpers/password-reset";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    const result = await authClient.requestPasswordReset({
      email,
      redirectTo: passwordResetRedirectUrl(window.location.origin),
    });

    setSubmitting(false);
    if (result.error) {
      setError(result.error.message ?? "Unable to request a password reset");
      return;
    }
    setSubmitted(true);
  }

  return (
    <main className="auth-shell">
      <ThemeToggle className="auth-theme" />
      <section className="auth-copy">
        <Badge>Account recovery</Badge>
        <h1>
          Find your way
          <br />
          <em>back in.</em>
        </h1>
        <p>Request a secure, time-limited link to choose a new password.</p>
      </section>
      <Card className="auth-card">
        <div className="mark">
          <MagnusOperaIcon /> Insights
        </div>
        <h2>{submitted ? "Check your email" : "Reset your password"}</h2>
        {submitted ? (
          <>
            <p>
              If an account exists for that address, we sent a password-reset
              link. The link expires in one hour.
            </p>
            <Link className="auth-text-link" to="/">
              Return to sign in
            </Link>
          </>
        ) : (
          <>
            <p>Enter the email address associated with your Insights account.</p>
            <form onSubmit={submit}>
              <label>
                Email
                <Input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="email"
                  required
                />
              </label>
              {error && <div className="error">{error}</div>}
              <Button type="submit" disabled={submitting}>
                {submitting ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <Link className="auth-text-link" to="/">
              Return to sign in
            </Link>
          </>
        )}
      </Card>
    </main>
  );
}
